var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3C13.2652 3 13.5196 3.10536 13.7071 3.29289C13.8946 3.48043 14 3.73478 14 4V8.535L17.928 6.268C18.1577 6.1354 18.4306 6.09946 18.6868 6.1681C18.943 6.23674 19.1614 6.40433 19.294 6.634L20.294 8.366C20.4266 8.59568 20.4625 8.86863 20.3939 9.1248C20.3253 9.38097 20.1577 9.59939 19.928 9.732L16.001 12L19.928 14.269C20.1577 14.4016 20.3253 14.62 20.3939 14.8762C20.4625 15.1324 20.4266 15.4053 20.294 15.635L19.294 17.367C19.1614 17.5967 18.943 17.7643 18.6868 17.8329C18.4306 17.9015 18.1577 17.8656 17.928 17.733L14 15.464V20C14 20.2652 13.8946 20.5196 13.7071 20.7071C13.5196 20.8946 13.2652 21 13 21H11C10.7348 21 10.4804 20.8946 10.2929 20.7071C10.1054 20.5196 9.99999 20.2652 9.99999 20V15.464L6.07199 17.732C5.84231 17.8646 5.56937 17.9005 5.3132 17.8319C5.05702 17.7633 4.83861 17.5957 4.70599 17.366L3.70599 15.634C3.57339 15.4043 3.53746 15.1314 3.60609 14.8752C3.67473 14.619 3.84232 14.4006 4.07199 14.268L7.99899 12L4.07199 9.732C3.84232 9.59939 3.67473 9.38097 3.60609 9.1248C3.53746 8.86863 3.57339 8.59568 3.70599 8.366L4.70599 6.634C4.83861 6.40433 5.05702 6.23674 5.3132 6.1681C5.56937 6.09946 5.84231 6.1354 6.07199 6.268L9.99999 8.535V4C9.99999 3.73478 10.1054 3.48043 10.2929 3.29289C10.4804 3.10536 10.7348 3 11 3H13Z",
    stroke: "#3545DE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCross);
export default __webpack_public_path__ + "static/media/medicalCross.bd404456bb8d346ae1d3b26966a24346.svg";
export { ForwardRef as ReactComponent };